module.exports = __webpack_public_path__ + "img/front1.0efd55fb.jpg";